<template>
  <div v-if="visible">
    <button
      v-if="!value"
      class="button is-primary is-light help-btn is-rounded is-hidden-mobile pulse"
      @click="show()"
    >
      <span class="icon is-small">
        <i class="mdi mdi-help"></i>
      </span>
    </button>
    <div v-if="value" class="modal" :class="{ 'is-active': value }">
      <div class="modal-background" @click="hide()"></div>
      <div class="modal-content">
        <transition
          name="custom-classes-transition"
          enter-active-class="pulse-fast-once"
          appear
        >
          <div class="box">
            <div class="has-text-right dismiss-text">
              <a @click.stop="hideForever()">Don't show this again</a>
            </div>
            <h2 class="h2 is-size-3 has-text-centered margin-bottom-25">
              <span v-if="step != 5">Get Started</span>
              <span v-if="step == 5">Completed</span>
            </h2>
            <ul
              class="steps is-narrow is-medium is-centered has-content-centered"
            >
              <li class="steps-segment" :class="{ 'is-active': step == 1 }">
                <span class="steps-marker">
                  <span class="icon">
                    <i class="mdi mdi-domain-plus"></i>
                  </span>
                </span>
                <div class="steps-content">
                  <p class="heading">Create Domain</p>
                </div>
              </li>

              <li class="steps-segment" :class="{ 'is-active': step == 2 }">
                <span class="steps-marker">
                  <span class="icon">
                    <i class="mdi mdi-domain"></i>
                  </span>
                </span>
                <div class="steps-content">
                  <p class="heading">Go to the new Domain</p>
                </div>
              </li>

              <li class="steps-segment" :class="{ 'is-active': step == 3 }">
                <span class="steps-marker">
                  <span class="icon">
                    <i class="mdi mdi-cloud-download"></i>
                  </span>
                </span>
                <div class="steps-content">
                  <p class="heading">Download Agent</p>
                </div>
              </li>

              <li class="steps-segment" :class="{ 'is-active': step == 4 }">
                <span class="steps-marker">
                  <span class="icon">
                    <i class="mdi mdi-package-variant"></i>
                  </span>
                </span>
                <div class="steps-content">
                  <p class="heading">Install Agent</p>
                </div>
              </li>

              <li class="steps-segment" :class="{ 'is-active': step == 5 }">
                <span class="steps-marker">
                  <span class="icon">
                    <i class="mdi mdi-auto-fix"></i>
                  </span>
                </span>
                <div class="steps-content">
                  <p class="heading">Ready to install packages</p>
                </div>
              </li>
            </ul>

            <slot></slot>
          </div>
        </transition>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hide()"
      ></button>
    </div>
  </div>
</template>

<style scoped>
.modal-content {
  width: fit-content;
}

.help-btn {
  position: absolute;
  top: 70%;
  right: 50px;
}

.dismiss-text {
  font-size: 11px;
}
</style>

<script>
export default {
  props: {
    value: Boolean,
    step: Number,
  },

  computed: {
    visible() {
      return (
        !this.isLoading &&
        (this.$store.state.settings.user?.profile?.guides?.getStarted ===
          undefined ||
          this.$store.state.settings.user?.profile?.guides?.getStarted)
      );
    },
  },
  components: {
    SimpleModal: () => import("@/components/singles/SimpleModal.vue"),
  },
  async created() {
    this.isLoading = true;
    await this.$store.dispatch("settings/getUserSetting", {
      path: "profile",
      xKey: "guides",
    });
    this.isLoading = false;
  },
  data() {
    return { isLoading: false };
  },

  methods: {
    show() {
      this.$emit("input", true);
    },
    hide() {
      this.$emit("input", false);
    },
    action(val) {
      this.$emit("action", val);
    },
    async hideForever() {
      await this.$store.dispatch("settings/setUser", {
        path: "profile",
        key: "guides",
        value: { getStarted: false },
      });
      this.$helpers.notify(
        "Deactivated",
        'You can reactivate the "Get Started"-guide in the profile settings.',
        "success",
        8000
      );
    },
  },
};
</script>
